module.exports = __webpack_public_path__ + "static/img/bg-es.8fe698d1.png";